export enum ExpenseSheetStatusEnum {
  DRAFT = "DRAFT",
  CONFIRMED = "CONFIRMED",
}

export function getExpenseSheetStatusLabel(status: ExpenseSheetStatusEnum): string {
  const labels: Record<ExpenseSheetStatusEnum, string> = {
    [ExpenseSheetStatusEnum.DRAFT]: "Borrador",
    [ExpenseSheetStatusEnum.CONFIRMED]: "Confirmado",
  };
  return labels[status] || status;
}

export const getExpenseSheetStatusOptions = (): { label: string; value: string }[] => {
  const keys = Object.keys(ExpenseSheetStatusEnum).filter(
    (key: string) => typeof ExpenseSheetStatusEnum[key as keyof typeof ExpenseSheetStatusEnum] === "string"
  );
  return keys.map((val) => {
    const value = ExpenseSheetStatusEnum[val as keyof typeof ExpenseSheetStatusEnum];
    return { label: getExpenseSheetStatusLabel(value), value: value };
  });
};
